import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons';
import { InlineTooltip } from "../inputs/InlineTooltip";
export const NonInputFieldLabelWrapper = ({
  label = '',
  error = false,
  errorText = 'This field is required',
  required = false,
  children,
  className = '',
  tooltip,
  tooltipDirection
}) => {
  return <div className="non-input-label-wrapper">
      <label className={`non-input-label ${error ? 'invalid' : ''} ${className}`}>
        {required ? `${label}* ` : `${label} `}
        {tooltip && <div className="tooltip-group">
            <InlineTooltip tooltip={tooltip} icon={faExclamationTriangle} direction={tooltipDirection} />
          </div>}
      </label>
      {children}
      {error && <div className="non-input-label__error">
          <i className="non-input-label__error-icon icon--solid foundry-icon icon--exclamation-triangle icon--red"></i>
          <span className="non-input-label__error-message">{errorText}</span>
        </div>}
    </div>;
};